import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import {
	performGetRequest,
	performPostRequest,
} from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { PACKAGE_NAME } from '../../common/constants.tsx';
import type { SettingsGet, SettingsSet } from '../../common/types.tsx';

export const get = async (): Promise<SettingsGet> => {
	try {
		return await performGetRequest('/rest/internal/3/announcement-banner');
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// 403 - banner is set to private and user is anonymous
		if (error.statusCode === 403) {
			return {
				message: '',
				isEnabled: false,
				isDismissable: false,
				visibility: 'private',
				hashId: '',
			};
		}

		trackFetchErrors({
			error,
			id: 'settingsGet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};

export const set = async (body: SettingsSet): Promise<SettingsGet> => {
	try {
		return await performPostRequest('/rest/internal/3/announcement-banner', {
			body: JSON.stringify(body),
		});
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		trackFetchErrors({
			error,
			id: 'settingsSet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};
